import _ from 'lodash';
import React, { Component } from 'react';
import Cropper from 'react-cropper';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

@observer
class ImageUpload extends Component {
	constructor(props) {
		super(props);

		this.state = {
			src: '',
			cropResult: null,
		};
	}

	componentDidMount () {
		const { imgPath, imgSrc, store } = this.props;
		const [ uploadFile ] = store.get('editImage.uploadImage') || [];

		if (_.isObject(uploadFile)) {

			this.readFile(uploadFile);
			return;
		}

		this.setState({
			src: (/^data/).test(imgSrc) ? imgSrc : imgPath
		});
	}

	@autobind
	onChange (evt) {
		evt.preventDefault();
		const { dataTransfer, target } = evt;
		let files;

		if (dataTransfer) {

			files = dataTransfer.files;
		} else if (target) {

			files = target.files;
		}

		this.readFile(_.first(files));
	}

	readFile (file) {
		const reader = new FileReader();

		reader.onload = () => {
			this.setState({ src: reader.result });
		};

		reader.readAsDataURL(file);
	}

	@autobind
	cropImage () {
		const { height = 400, width = 400 } = this.props;
		const croppedCanvas = this.cropper.getCroppedCanvas({
			width, height
		});//'image/jpeg', 0.9);

		if (_.isUndefined(croppedCanvas)) {

			return;
		}

		const cropResult = croppedCanvas.toDataURL();
		this.props.handleImageCrop(cropResult);
		this.setState({ cropResult });
	}

	render () {
		const {
			height = 400,
			width = 400,
			aspectRatio = 1,
			imgClassName = 'image large'
		} = this.props;

		return (
			<div className="grid-container">
				<div className="grid-x grid-padding-x">
					<div className="cell auto">
						<h5>Crop Image</h5>
						<Cropper
							style={{
								height: `${height}px`,
								width: `${width}px`
							}}
							aspectRatio={ aspectRatio }
							preview=".img-preview"
							guides={ false }
							src={ this.state.src }
							crossOrigin="anonymous"
							ref={ (cropper) => { this.cropper = cropper; } }
						/>

						<label htmlFor="imageUpload" className="button clear padding-left-0">
							<span className="fas fa-image"></span> Choose New Image
						</label>

						<input
							type="file"
							accept=".png, .jpg, .jpeg"
							id="imageUpload"
							data-ta="imageUpload"
							className="show-for-sr"
							onChange={ this.onChange }
						/>
					</div>

					<div className="cell shrink">
						<h5>Image Preview</h5>
						<div className={ `img-preview ${imgClassName}` } style={{ overflow: 'hidden' }}></div>
					</div>
				</div>

				<div className="modal-button-group">
					{ this.props.children || null }
					<button className="button clear" onClick={ this.cropImage }>
						<span className="fas fa-save"></span> Save Image
					</button>
				</div>
			</div>
		);
	}
}

export default ImageUpload;
